import { render } from "./NavbarLink.vue?vue&type=template&id=45298253"
import script from "./NavbarLink.vue?vue&type=script&lang=js"
export * from "./NavbarLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__